var map = {
	"./EagleGlobalMarkets-white.svg": "7eb7",
	"./ICMTrader-white.svg": "d8b9",
	"./TDSouthAfrica-white.svg": "726e",
	"./WLGravity-white.svg": "b40e",
	"./icm-white.svg": "2194",
	"./mark-white.svg": "753d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87f3";